import { GetStaticPaths, GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { StoreProductsPage } from '@/pages/StoreProducts';
import { fetchShopifyProducts, transformShopifyProducts } from '@/entities/shopify';
import { deviceType } from '@/shared/constants';
import { parseSSGParams, getPaths } from '@/shared/helpers';
import { i18n } from 'next-i18next.config';

export const getStaticProps: GetStaticProps = async (context) => {
  const { device } = parseSSGParams(context.params);

  const isValidPath = Object.values(deviceType).includes(device);

  if (!isValidPath) {
    return {
      notFound: true,
    };
  }

  try {
    const allShopifyProducts = await fetchShopifyProducts();
    const products =
      allShopifyProducts && allShopifyProducts.length > 0
        ? transformShopifyProducts(allShopifyProducts)
        : [];

    return {
      props: {
        ...(await serverSideTranslations(context.locale || i18n.defaultLocale, ['common'])),
        products,
      },
    };
  } catch (error) {
    console.error('[StoreProducts] Error fetching from Shopify:', error);
    return {
      props: {
        ...(await serverSideTranslations(context.locale || i18n.defaultLocale, ['common'])),
        products: [],
        device,
      },
    };
  }
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPaths();

  return {
    paths,
    fallback: 'blocking',
  };
};

export default StoreProductsPage;
